import { Link } from 'react-router-dom';
import { useGameStore } from '../store/useGameStore';
import { EssenceChip } from './EssenceChip';
import { PlayerNamePill } from './PlayerNamePill';

// Shared top bar. `back` renders a "← lobby" link; otherwise the brand subtitle.
export function AppHeader({
  subtitle,
  back = false,
  center,
}: {
  subtitle?: string;
  back?: boolean;
  center?: React.ReactNode;
}) {
  const user = useGameStore((s) => s.user);
  return (
    <header className="flex-none px-6 py-3 border-b border-slate-900 flex items-center justify-between gap-6">
      <div className="flex items-baseline gap-4 min-w-0">
        {back ? (
          <Link to="/" className="flex items-center gap-1.5 text-slate-400 hover:text-slate-200 text-sm">
            <span className="text-lg leading-none">←</span>
            <span className="hidden sm:inline">lobby</span>
          </Link>
        ) : (
          <Link to="/" className="text-2xl tracking-wide text-slate-100 hover:text-amber-100">
            Spirits
          </Link>
        )}
        {subtitle && <p className="text-slate-500 text-xs hidden md:block truncate">{subtitle}</p>}
      </div>
      {center}
      <div className="flex items-center gap-3 flex-none">
        <EssenceChip />
        {user && <PlayerNamePill playerName={user.playerName} />}
      </div>
    </header>
  );
}
